export default class QueryParameterError extends Error {
  isQueryParameterError = true
}
